import './styles.css';
import { registerScreen, startRouter } from '@shell/router';
import { hubScreen } from '@shell/screens/hub';
import { academyScreen } from '@shell/screens/academy';
import { wildsScreen } from '@shell/screens/wilds';
import { shopScreen } from '@shell/screens/shop';
import { houseScreen } from '@shell/screens/house';
import { studioScreen } from '@shell/screens/studio';
import { parentScreen } from '@shell/screens/parent';
import { playScreen } from '@shell/screens/play';
import { townScreen } from '@shell/screens/town';
import { petsScreen } from '@shell/screens/pets';
import { mapScreen } from '@shell/screens/map';
import { bookshelfScreen } from '@shell/screens/bookshelf';
import { charmsScreen } from '@shell/screens/charms';
import { wildsMapScreen } from '@shell/screens/wilds-map';
import { regionScreen } from '@shell/screens/region';
import { getSave } from '@shell/state';
import { setTtsEnabled } from '@kit/tts';
import { setSoundEnabled } from '@kit/audio';

registerScreen('hub', hubScreen);
registerScreen('academy', academyScreen);
registerScreen('wilds', wildsScreen);
registerScreen('shop', shopScreen);
registerScreen('house', houseScreen);
registerScreen('studio', studioScreen);
registerScreen('parent', parentScreen);
registerScreen('play', playScreen);
registerScreen('town', townScreen);
registerScreen('pets', petsScreen);
registerScreen('map', mapScreen);
registerScreen('bookshelf', bookshelfScreen);
registerScreen('charms', charmsScreen);
registerScreen('wilds-map', wildsMapScreen);
registerScreen('region', regionScreen);

import { preloadArt } from '@kit/assets';
import { preloadVoice } from '@kit/voice';

const s = getSave();
setTtsEnabled(s.settings.tts);
setSoundEnabled(s.settings.sound);
preloadArt();
preloadVoice();

startRouter(document.getElementById('app')!);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => { /* offline is a bonus, not a requirement */ }); });
}
